export const news = [
  {
    id: 'guebly-games-fundacao',
    category: 'Estúdio',
    categoryColor: '#00A3FF',
    date: '20 Ago 2025',
    title: 'Guebly Games é fundada como braço criativo da Guebly',
    excerpt: 'A Guebly anuncia oficialmente a criação da Guebly Games, estúdio dedicado ao desenvolvimento de jogos autorais, experiências XR e gamificação aplicada.',
    content: 'A Guebly deu mais um passo na expansão do seu ecossistema criativo com a fundação da Guebly Games. O novo estúdio nasce com a missão de criar propriedades intelectuais originais que conectem pessoas através do jogo. Com uma equipe multidisciplinar e uma visão clara de identidade brasileira no mercado global, a Guebly Games chega para ocupar um espaço que estava esperando ser preenchido.',
    readTime: '3 min',
    featured: true,
  },
  {
    id: 'guebly-engine-anuncio',
    category: 'Engine',
    categoryColor: '#00FF88',
    date: '05 Nov 2025',
    title: 'Guebly Engine: a engine de jogos feita no Brasil para o mundo',
    excerpt: 'A Guebly Games anuncia sua própria engine de desenvolvimento de jogos — com editor visual, scripting Lua, renderer 2D/3D e export multiplataforma.',
    content: 'A Guebly Games dá um passo histórico no desenvolvimento de games nacional: anuncia a Guebly Engine, sua própria plataforma de desenvolvimento de jogos. Com editor visual intuitivo, scripting em Lua, renderer 2D/3D otimizado, sistema de física, áudio 3D espacial e export multiplataforma, a Guebly Engine foi projetada para ser acessível a iniciantes e poderosa o suficiente para profissionais. O lançamento marca a transição da Guebly Games de estúdio para plataforma completa. A engine estará disponível em versão beta em engine.games.guebly.com.br.',
    readTime: '6 min',
    featured: false,
  },
  {
    id: 'guebly-store-anuncio',
    category: 'Lançamento',
    categoryColor: '#C45A3A',
    date: '10 Nov 2025',
    title: 'Guebly Store: a loja de jogos que o Brasil precisava',
    excerpt: 'Taxa justa para desenvolvedores (15-20%), pagamento via PIX, launcher dedicado e foco na comunidade brasileira. Conheça a Guebly Store.',
    content: 'A Guebly Games apresenta a Guebly Store — uma loja de jogos criada para democratizar a distribuição de games no Brasil. Com taxa de 15 a 20% para desenvolvedores (contra 30% do mercado tradicional), pagamento via PIX, launcher dedicado e curadoria focada em títulos independentes, a Store nasce para resolver um problema real do ecossistema de games brasileiro. Qualquer desenvolvedor pode publicar seu jogo em dev.games.guebly.com.br. A Store estará disponível em store.games.guebly.com.br.',
    readTime: '5 min',
    featured: false,
  },
  {
    id: 'void-protocol-reveal',
    category: 'Jogos',
    categoryColor: '#00A3FF',
    date: '25 Ago 2025',
    title: 'Void Protocol: primeiro título da Guebly Games revelado',
    excerpt: 'O estúdio revela seu primeiro projeto: um jogo de ação sci-fi ambientado em 2087, onde memórias humanas são a moeda mais valiosa do mundo.',
    content: 'Após meses de desenvolvimento silencioso, a Guebly Games revela oficialmente Void Protocol — seu primeiro grande título. Ambientado em 2087, o jogo explora um futuro onde a memória humana pode ser transferida, vendida e roubada. O protagonista KAI-7 deve navegar por uma dimensão digital chamada "o Void" para recuperar o que foi tomado. O jogo está previsto para 2026.',
    readTime: '5 min',
    featured: false,
  },
  {
    id: 'jogos-web-lancamento',
    category: 'Lançamento',
    categoryColor: '#00FF88',
    date: '01 Set 2025',
    title: 'Três jogos web chegam ao portal Guebly Games',
    excerpt: 'Drum Kit, Memory e Tic Tac Toe chegam ao site com visual reimaginado na estética da Guebly. Gratuitos, direto no browser, sem instalação.',
    content: 'Como parte da estratégia de engajamento da comunidade, a Guebly Games lança três jogos web gratuitos: uma bateria virtual com compositor automático, um jogo da memória com sistema de pontuação e o clássico jogo da velha com IA Minimax. Todos disponíveis direto no browser, sem cadastro ou instalação.',
    readTime: '2 min',
    featured: false,
  },
  {
    id: 'raizes-conceito',
    category: 'Desenvolvimento',
    categoryColor: '#C800FF',
    date: '10 Set 2025',
    title: 'RAÍZES: o RPG brasileiro que o mundo nunca viu',
    excerpt: 'Inspirado no folclore e na cultura do Brasil, RAÍZES promete ser um marco para a produção de propriedade intelectual nacional no mercado global de games.',
    content: 'A Guebly Games anuncia seu segundo projeto em desenvolvimento: RAÍZES. Um RPG de mundo aberto que leva o folclore brasileiro — Cuca, Saci, Boto-cor-de-rosa, Iara — para o centro da narrativa. A protagonista Yaci percorre o Brasil em uma jornada que mistura aventura, mitologia e crítica social. RAÍZES é uma declaração de que histórias brasileiras têm lugar no mercado global.',
    readTime: '7 min',
    featured: false,
  },
  {
    id: 'comunidade-discord',
    category: 'Comunidade',
    categoryColor: '#C800FF',
    date: '15 Out 2025',
    title: 'Comunidade Guebly Games cresce para 5 mil membros',
    excerpt: 'Em menos de dois meses, a comunidade da Guebly Games já reúne mais de 5 mil gamers apaixonados por jogos autorais e experiências imersivas.',
    content: 'Dois meses após o lançamento do portal e dos primeiros jogos web, a comunidade Guebly Games já tem mais de 5 mil membros ativos. O Discord virou ponto de encontro para discussões sobre game design, narrativa e desenvolvimento independente. A Guebly Games agradece cada membro que acreditou no projeto desde o início.',
    readTime: '2 min',
    featured: false,
  },
];

export const getNewsById = (id) => news.find(n => n.id === id);
export const getFeaturedNews = () => news.find(n => n.featured) || news[0];
